import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import {
  Avatar,
  ListItemIcon,
  ListItemText,
  Stack,
  Typography,
  useTheme,
} from "@mui/material";
import Button from "@mui/material/Button";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import PopupState, { bindMenu, bindTrigger } from "material-ui-popup-state";
import * as React from "react";
import { useNavigate } from "react-router-dom";
import LogoutIcon from "@mui/icons-material/Logout";
import { appIcons, appImages } from "../../assets";
import { useDispatch, useSelector } from "react-redux";
import GridViewIcon from "@mui/icons-material/GridView";
import { setUserData } from "../../lib/redux/slices/userSlice";

const style = {
  menuButton: {
    padding: "4px 8px",
    fontSize: "1rem",
    color: "#000000",
  },
};

export default function ProfileMenu() {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { palette } = useTheme();
  const userData = useSelector((state) => state.userReducer.user);
  const username = `${userData?.firstname} ${userData?.lastname}`;

  return (
    <PopupState width="100%" variant="popover" popupId="demo-popup-menu">
      {(popupState) => (
        <React.Fragment>
          <Button
            {...bindTrigger(popupState)}
            variant="contained"
            disableRipple
            startIcon={
              <Avatar
                src={userData?.profileImg}
                sx={{ height: 26, width: 26, border: "2px solid #ffffff" }}
              />
            }
            endIcon={
              <KeyboardArrowDownIcon
                htmlColor="#ffffff"
                sx={{ fontSize: "1.5rem !important" }}
              />
            }
            sx={{
              display: { xs: "none", md: "flex" },
              justifyContent: "space-between",
              width: 160,
              height: 45,
              background: palette.gradient.button,
              border: "none",
              borderRadius: "6px",
              padding: "6px 12px",
              backgroundColor: "text.coralRed",
              "&:hover": {
                boxShadow: "none",
              },
            }}
          >
            <Typography variant="body2" noWrap>
              {username}
            </Typography>
          </Button>
          <Menu
            disableScrollLock
            {...bindMenu(popupState)}
            PaperProps={{
              sx: {
                top: "60px !important",
                width: "160px",
              },
            }}
          >
            <Stack
              justifyContent={"center"}
              alignItems={"center"}
              width={"100%"}
              p="5px"
            >
              <Avatar
                src={userData?.profileImg}
                sx={{
                  height: 60,
                  width: 60,
                }}
              />
              <Typography
                mt={2}
                px={1}
                fontSize={"0.875rem"}
                fontWeight={"500"}
                textAlign={"center"}
                whiteSpace={"break-spaces"}
              >
                {username}
              </Typography>
            </Stack>

            <MenuItem
              onClick={() => {
                navigate("/dashboard");
              }}
              sx={{ ...style.menuButton }}
            >
              <ListItemIcon sx={{ minWidth: "25px !important" }}>
                <GridViewIcon
                  sx={{ fontSize: "1.125rem", color: "primary.main" }}
                />
              </ListItemIcon>
              <ListItemText
                primary={"Dashboard"}
                sx={{
                  "& .MuiListItemText-primary": {
                    fontSize: "0.875rem",
                    color: "text.coolGrey",
                  },
                }}
              />
            </MenuItem>
            <MenuItem
              onClick={() => {
                popupState.close();
                localStorage.removeItem("user_data");
                dispatch(setUserData(null));
                navigate("/");
              }}
              sx={{ ...style.menuButton }}
            >
              <ListItemIcon sx={{ minWidth: "25px !important" }}>
                <LogoutIcon
                  sx={{ fontSize: "1.125rem", color: "primary.main" }}
                />
              </ListItemIcon>
              <ListItemText
                primary={"Logout"}
                sx={{
                  "& .MuiListItemText-primary": {
                    fontSize: "0.875rem",
                    color: "text.coolGrey",
                  },
                }}
              />
            </MenuItem>
          </Menu>
        </React.Fragment>
      )}
    </PopupState>
  );
}
